import type { Middleware } from '@/types/router';

export default [
    {
        path: '/',
        redirect: '/event',
        name: 'home',
        meta: {
            title: 'Home',
            nav: 'Home',
            middleware: [] as Middleware[]
        }
    }
];
